import { createReducer } from 'src/helpers/reducer';
import actionTypes from './actionTypes';
import type { IJobTypesListState, ILoadDataSuccessPayload } from './types';

const initState: IJobTypesListState = {
  jobTypes: null,
  loading: false,
  total: 0,
  filteredTotal: 0,
  filters: null,
  sortableColumns: [],
};

function onLoadRequest(state: IJobTypesListState): IJobTypesListState {
  return { ...state, loading: true };
}

function onLoadSuccess(
  state: IJobTypesListState,
  { payload }: { payload: ILoadDataSuccessPayload },
): IJobTypesListState {
  const { records, total, filteredTotal, filters, sortableColumns } = payload;

  return { ...state, jobTypes: records, total, filteredTotal, filters, sortableColumns, loading: false };
}

// Keeps the last successful rows; the saga reports the failure as a toast.
function onLoadError(state: IJobTypesListState): IJobTypesListState {
  return { ...state, loading: false };
}

export default createReducer(initState, {
  [actionTypes.LOAD_DATA_REQUEST]: onLoadRequest,
  [actionTypes.LOAD_DATA_SUCCESS]: onLoadSuccess,
  [actionTypes.LOAD_DATA_ERROR]: onLoadError,
  [actionTypes.CLEAR_STORE]: () => initState,
});
